export const WEB_TERMS_VERSION = "eula_v1";
export const WEB_PRIVACY_VERSION = "privacy_policy_v1";
export const PENDING_CONSENT_KEY = "stratify.pendingConsent";

export function buildWebConsent() {
  return {
    accepted: true,
    termsVersion: WEB_TERMS_VERSION,
    privacyVersion: WEB_PRIVACY_VERSION,
    noFinancialAdvice: true,
  };
}

export function storePendingConsent() {
  try {
    sessionStorage.setItem(PENDING_CONSENT_KEY, JSON.stringify(buildWebConsent()));
  } catch {
    /* ignore quota */
  }
}

export function readPendingConsent() {
  try {
    const raw = sessionStorage.getItem(PENDING_CONSENT_KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}

export function clearPendingConsent() {
  try {
    sessionStorage.removeItem(PENDING_CONSENT_KEY);
  } catch {
    /* ignore */
  }
}
